import API from "serviceshift-ui/api-client";

export default {
  async archiveTimeCard(_, data) {
    const res = await API.makeRequest(
      `/admin/v4/time_cards/${data.id}/archive`,
      {
        method: "PATCH"
      }
    );
    return res.data;
  },
  async fetchTimeCardEmployees({ commit }) {
    const res = await API.makeRequest("/admin/v4/time_cards/employees", {
      method: "GET"
    });
    commit("replace", {
      state: "timeCardEmployees",
      data: res.data
    });
  },
  async fetchTimeCard(_, { id }) {
    const res = await API.makeRequest(`/admin/v4/time_cards/${id}`, {
      method: "GET"
    });
    return res.data;
  },
  async createTimeCard(_, data) {
    const res = await API.makeRequest(`/admin/v4/time_cards`, {
      method: "POST",
      data
    });
    return res.data;
  },
  async updateTimeCard(_, data) {
    const res = await API.makeRequest(`/admin/v4/time_cards/${data.id}`, {
      method: "PUT",
      data
    });
    return res.data;
  },
  async unarchiveTimeCard(_, data) {
    const res = await API.makeRequest(
      `/admin/v4/time_cards/${data.id}/unarchive`,
      {
        method: "PATCH"
      }
    );
    return res.data;
  }
};
